import { LocalityReference } from 'app/model/LocalityReference';
import { Reference } from 'app/model/Reference';

/**
 * Адрес населённого пункта
 */
export class LocalityAddress {
    static readonly BELARUS_COUNTRY_CODE = '112';

    /**
     * Код COATO (используется, если страна Беларусь)
     */
    soatoCode: string;

    /**
     * Страна (цифровой код)
     */
    countryCode: string;

    /**
     * Область (может отсутствовать)
     */
    region: string;

    /**
     * Район (может отсутствовать)
     */
    district: string;

    /**
     * Сельсовет (может отсутствовать)
     */
    villageCouncil: string;

    /**
     * Тип населённого пункта (город/поселок и т.п.)
     */
    localityType: string;

    /**
     * Название населённого пункта
     */
    locality: string;

    get isBelarus() {
        return this.countryCode === LocalityAddress.BELARUS_COUNTRY_CODE;
    }

    constructor(
        soatoCode?: string,
        countryCode?: string,
        localityType?: string,
        locality?: string,
        region?: string,
        district?: string,
        villageCouncil?: string,
    ) {
        this.soatoCode = soatoCode;
        this.countryCode = countryCode;
        this.region = region;
        this.district = district;
        this.villageCouncil = villageCouncil;
        this.localityType = localityType;
        this.locality = locality;
    }

    static reference(
        localityReference: LocalityReference,
        birthCountry: Reference,
    ) {
        return new LocalityAddress(
            localityReference.soato,
            birthCountry.id,
            localityReference.type,
            localityReference.name,
            localityReference.region,
            localityReference.district,
            localityReference.ruralCouncil,
        );
    }

    static belarus() {
        const localityAddress = new LocalityAddress();
        localityAddress.countryCode = LocalityAddress.BELARUS_COUNTRY_CODE;

        return localityAddress;
    }

    static default(country: string, localityType: string, locality: string) {
        return new LocalityAddress(country, localityType, locality);
    }

    static empty() {
        return new LocalityAddress();
    }

    static deserialize(data: any) {
        return !!data
            ? new LocalityAddress(
                  data.soatoCode,
                  data.countryCode,
                  data.localityType,
                  data.locality,
                  data.region,
                  data.district,
                  data.villageCouncil,
              )
            : null;
    }
}
